<script setup>
import { ref } from 'vue';
import { useScrollStore } from '@/stores/scrollStore';
import TheHeader from './TheHeader.vue';

const storeScroll = useScrollStore();

defineProps({
    pageLoaded: {
        type: Boolean
    },
    bgAttachment: {
        type: Boolean
    }
})

</script>
<template>
    <div :class="['main-screen', { animated: !pageLoaded }]" 
        :style="{'padding-top': storeScroll.headerFixed ? `${storeScroll.headerHeight}px` : '', 'background-attachment': bgAttachment ? 'fixed' : ''}"
    >
        <TheHeader :page-loaded />
        <div class="container">
            <h1 class="title main-screen__title" data-animation-left>
                <span class="title-border">GIFT</span>
                <span>CARDS</span>
            </h1>
            <div class="main-screen__content" data-animation-right>
                <p>Подарок, который вдохновляет на движение и заботу о себе. </p>
                <a href="##" @click="storeScroll.scrollToId('constructor')" class="btn">купить</a>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>

</style>